import { Input } from '@/components/ui/input';
import { useState, useEffect } from 'react';

const formatDisplay = (value) => {
  const stringValue = value ? String(value) : '';
  if (stringValue && stringValue.includes('-')) {
    const parts = stringValue.split('-');
    if (parts.length === 3 && parts[0].length === 4) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return stringValue;
  }
  return stringValue;
};

export default function DateInput({ value, onChange, ...props }) {
  const [displayValue, setDisplayValue] = useState(() => formatDisplay(value));

  useEffect(() => {
    setDisplayValue(formatDisplay(value));
  }, [value]);

  const handleChange = (e) => {
    let input = e.target.value.replace(/[^\d]/g, ''); // Only numbers
    
    // Limit to 8 digits (ddmmyyyy)
    input = input.slice(0, 8);
    
    // Auto-format as user types
    let formatted = '';
    
    if (input.length > 0) {
      // Day (max 2 digits)
      formatted = input.slice(0, 2);
    }
    if (input.length > 2) {
      // Add dash and month (max 2 digits)
      formatted += '-' + input.slice(2, 4);
    }
    if (input.length > 4) {
      // Add dash and year (max 4 digits)
      formatted += '-' + input.slice(4, 8);
    }
    
    setDisplayValue(formatted);
  };

  const handleBlur = () => {
    // Validate and convert to YYYY-MM-DD format on blur
    const parts = displayValue.split('-');
    
    if (parts.length === 3 && parts[0].length === 2 && parts[1].length === 2 && parts[2].length === 4) {
      const day = parts[0];
      const month = parts[1];
      const year = parts[2];
      
      // Basic validation
      const dayNum = parseInt(day, 10);
      const monthNum = parseInt(month, 10);
      const yearNum = parseInt(year, 10);
      
      if (
        dayNum >= 1 && dayNum <= 31 &&
        monthNum >= 1 && monthNum <= 12 &&
        yearNum >= 1900 && yearNum <= 2100
      ) {
        // Valid date, convert to YYYY-MM-DD
        const isoDate = `${year}-${month}-${day}`;
        if (onChange) {
          onChange(isoDate);
        }
      } else {
        // Invalid date
        setDisplayValue('');
        if (onChange) {
          onChange('');
        }
      }
    } else if (displayValue === '') {
      // Empty is valid
      if (onChange) {
        onChange('');
      }
    }
  };

  return (
    <Input
      {...props}
      type="text"
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder="DD-MM-YYYY"
      maxLength={10}
    />
  );
}
